export default __webpack_public_path__ + "static/media/ff-screenshot-2.5e7114bf.png";